/** Applicable + applied visuals for unified listing platform action buttons. */
const ELITE_APPLICABLE = {
  background: 'linear-gradient(270deg, #E29D01 0%, #C99602 100%)',
  backgroundImage: 'linear-gradient(270deg, #E29D01 0%, #C99602 100%)',
  color: '#ffffff',
  border: 'none',
  contentColor: '#ffffff',
};

const ELITE_APPLIED = {
  background: '#FBF3E0',
  backgroundImage: 'none',
  color: '#C99602',
  border: 'none',
  contentColor: '#C99602',
  tickColor: '#C99602',
};

const FEATURED_APPLICABLE = {
  background: 'linear-gradient(88.97deg, rgba(20, 114, 236, 0.959574) -1.51%, #4D9FEB 126.44%)',
  backgroundImage: 'linear-gradient(88.97deg, rgba(20, 114, 236, 0.959574) -1.51%, #4D9FEB 126.44%)',
  color: '#ffffff',
  border: 'none',
  contentColor: '#ffffff',
};

const FEATURED_APPLIED = {
  background: '#EEF5FE',
  backgroundImage: 'none',
  color: '#4D9FEB',
  border: 'none',
  contentColor: '#4D9FEB',
  tickColor: '#4D9FEB',
};

const BOOST_APPLICABLE = {
  background: 'linear-gradient(90.12deg, #43BB3F -23.76%, #A1DD9F 158.42%)',
  backgroundImage: 'linear-gradient(90.12deg, #43BB3F -23.76%, #A1DD9F 158.42%)',
  color: '#ffffff',
  border: 'none',
  contentColor: '#ffffff',
};

const BOOST_APPLIED = {
  background: '#ECF8F0',
  backgroundImage: 'none',
  color: '#43BB3F',
  border: 'none',
  contentColor: '#43BB3F',
  tickColor: '#43BB3F',
};

export const UNIFIED_LISTING_ACTION_CONFIG_BY_SLUG = {
  'signature-listing': {
    labelKey: 'unifiedBadgeElite',
    iconOnlyApplicable: false,
    actionIcon: null,
    size: { width: 61, height: 29, fontSize: 14 },
    applicable: ELITE_APPLICABLE,
    applied: ELITE_APPLIED,
  },
  'elite-listing': {
    labelKey: 'unifiedBadgeElite',
    iconOnlyApplicable: false,
    actionIcon: null,
    size: { width: 61, height: 29, fontSize: 14 },
    applicable: ELITE_APPLICABLE,
    applied: ELITE_APPLIED,
  },
  'hot-listing': {
    labelKey: 'unifiedActionFeature',
    appliedLabelKey: 'unifiedBadgeFeatured',
    iconOnlyApplicable: false,
    actionIcon: null,
    size: { width: 81, height: 29, fontSize: 14 },
    applicable: FEATURED_APPLICABLE,
    applied: FEATURED_APPLIED,
  },
  feature: {
    labelKey: 'unifiedActionFeature',
    appliedLabelKey: 'unifiedBadgeFeatured',
    iconOnlyApplicable: false,
    actionIcon: null,
    size: { width: 81, height: 29, fontSize: 14 },
    applicable: FEATURED_APPLICABLE,
    applied: FEATURED_APPLIED,
  },
  refresh: {
    labelKey: 'Boost to Top',
    iconOnlyApplicable: true,
    actionIcon: 'MdRefresh',
    size: { width: 52, height: 29, fontSize: 14 },
    applicable: BOOST_APPLICABLE,
    applied: BOOST_APPLIED,
  },
  'boost-to-top': {
    labelKey: 'Boost to Top',
    iconOnlyApplicable: true,
    actionIcon: 'MdRefresh',
    size: { width: 29, height: 29, fontSize: 14 },
    applicable: BOOST_APPLICABLE,
    applied: BOOST_APPLIED,
  },
};

export const getUnifiedListingActionConfig = (slug) =>
  slug ? UNIFIED_LISTING_ACTION_CONFIG_BY_SLUG[slug] ?? null : null;

export const getUnifiedListingActionVisuals = (slug, isApplied) => {
  const config = getUnifiedListingActionConfig(slug);
  if (!config) return null;
  return isApplied ? config.applied : config.applicable;
};
